var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    stroke: "#BDBDBD",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.043 15H9.33984V14.5723C9.44141 14.5645 9.54102 14.5547 9.63867 14.543C9.73633 14.5312 9.82031 14.5117 9.89062 14.4844C10.0156 14.4375 10.1035 14.3711 10.1543 14.2852C10.2051 14.1953 10.2305 14.0781 10.2305 13.9336V10.5234C10.2305 10.3867 10.1992 10.2676 10.1367 10.166C10.0742 10.0605 9.99609 9.97656 9.90234 9.91406C9.83203 9.86719 9.72461 9.82227 9.58008 9.7793C9.43945 9.73633 9.31055 9.70898 9.19336 9.69727V9.26953L12.0645 9.11719L12.1523 9.20508V13.8574C12.1523 13.9941 12.1816 14.1113 12.2402 14.209C12.2988 14.3027 12.3828 14.373 12.4922 14.4199C12.5703 14.4551 12.6562 14.4863 12.75 14.5137C12.8438 14.541 12.9414 14.5605 13.043 14.5723V15ZM12.1875 7.00781C12.1875 7.30469 12.0723 7.55859 11.8418 7.76953C11.6152 7.97656 11.3457 8.08008 11.0332 8.08008C10.7168 8.08008 10.4434 7.97656 10.2129 7.76953C9.98633 7.55859 9.87305 7.30469 9.87305 7.00781C9.87305 6.71094 9.98633 6.45703 10.2129 6.24609C10.4434 6.03516 10.7168 5.92969 11.0332 5.92969C11.3496 5.92969 11.6211 6.03516 11.8477 6.24609C12.0742 6.45703 12.1875 6.71094 12.1875 7.00781Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.a239d072dba80d168668c63bbfbaa481.svg";
export { ForwardRef as ReactComponent };